<template >
    <div>
        <el-dialog :title="title" :visible.sync="show" width="20%" center @close="handleSendMsg(1)">
            <span>{{content}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleSendMsg(0)" v-if="cancelAble">取 消</el-button>
                <el-button type="primary" size="large" @click="handleSendMsg(1)">{{confirmTxt}}</el-button>
            </span>
        </el-dialog>

    </div>

</template>
<script>
export default {
    props: ['title', 'content', 'show', 'cancelAble', 'confirmTxt'],//
    data() {
        return {

        }

    },
    methods: {
        handleSendMsg(type) {
            //type 0:取消 1：确认
            this.$emit('sendMsg', type)
        },
    }

}
</script>